import { LoadingService } from '@shared/services/loading.service';
import {Injectable} from '@angular/core';
import {environment} from "../../../../environments/environment";
import {HttpClient, HttpParams} from "@angular/common/http";
import {MessageErrorResolver} from "../../utilities/message-error-resolver";
import {catchError, EMPTY, finalize, map, Observable} from "rxjs";
import {IPage} from "../../models/pagination/page";
import {ResponseDto, ResponseWithErrorDto} from "../../models/exceptions/response-dto";
import {ICityDto} from "../../models/city-dto";
import { PageRequest } from '@models/pagination/page-request';
import { CitiesFilter } from '@modules/cities/list-cities/list-cities.component';
import { toParams } from '../../utilities/utility-functions';
import { CityPostForm } from '@modules/cities/edit-cities/form/city-post-form';

@Injectable({
  providedIn: 'root'
})
export class CityService {
  private url: string = environment.apiUrl + "/v1/cidades";

  constructor(private httpClient: HttpClient, private messageErrorResolver: MessageErrorResolver, private loadingService: LoadingService) {
  }

  public getAllCities(page?: number, size?: number): Observable<IPage<ICityDto>> {
    let params = new HttpParams();
    if (page) params = params.set("page", page);
    if (size) params = params.set("size", size);
    return this.httpClient.get<ResponseDto<IPage<ICityDto>>>(this.url, {params})
      .pipe(
        map(response => response.response),
        catchError((error: ResponseWithErrorDto) => {
          this.messageErrorResolver.resolveMessage(error);
          return EMPTY;
        })
      );
  }

  public getCitiesByFilter(page?:PageRequest,filter?:CitiesFilter){
    const params = toParams(page,filter)
    return this.httpClient.get<ResponseDto<IPage<ICityDto>>>(this.url+'/filtrar', {params})
      .pipe(
        map(response => response.response),
        catchError((error: ResponseWithErrorDto) => {
          this.messageErrorResolver.resolveMessage(error);
          return EMPTY;
        })
      );
  }


  public updateCity(cityPostForm:CityPostForm){

    return this.httpClient.post<ResponseDto<ICityDto>>(this.url,cityPostForm)
      .pipe(
        finalize(()=>this.loadingService.deactivate()),
        map(response => response.response),
        catchError((error: ResponseWithErrorDto) => {
          this.messageErrorResolver.resolveMessage(error);
          return EMPTY;
        })
      );
  }

  public deleteCityById(cidNrId:number){
     return this.httpClient.delete<ResponseDto<ICityDto>>(`${this.url}/${cidNrId}`)
      .pipe(
        map(() => undefined)
      );
  }

  public getCityById$(cidNrId: number): Observable<ICityDto> {
    return this.httpClient.get<ResponseDto<ICityDto>>(`${this.url}/${cidNrId}`)
      .pipe(
        map(response => response.response)
      );
  };
}
